import { ApplicationResponseStatus } from 'generatedTypes/flight/models';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('detailsViewCardApplicationListItem');

    const STATUS_LABELS: Record<ApplicationResponseStatus, string> = {
        [ApplicationResponseStatus.COMPLETE]: t('statusComplete'),
        [ApplicationResponseStatus.IN_PROGRESS]: t('statusInProgress'),
        [ApplicationResponseStatus.NOT_STARTED]: t('statusNotStarted')
    };

    return {
        DURATION: t('duration'),
        END: t('end'),
        FLIGHTS: t('flights'),
        START: t('start'),
        STATUS_LABELS
    };
};

export default useTranslation;
